import type {CargoRequirementChoice} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/api/form'

export function getCargoLoadersOptions(cargoTypeOption?: CargoRequirementChoice): number[] | undefined {
  return cargoTypeOption?.restrictions?.loaders_settings?.flatMap(setting =>
    setting.is_delivery_enabled ? setting.loaders_count : [],
  )
}
